/* Detox in 1 dag — theme behaviour
   Progressive enhancement only: every control has a working no-JS fallback. */
(function () {
  'use strict';

  var T = window.theme || {};
  var routes = T.routes || {};
  var strings = T.strings || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function on(root, evt, sel, fn) {
    root.addEventListener(evt, function (e) {
      var el = e.target.closest(sel);
      if (el && root.contains(el)) fn(e, el);
    });
  }

  /* ------------------------------------------------------------------ */
  /* dataLayer (Google Tag Manager)                                       */

  function dl(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  /* Any element can opt in with data-dl-event="name" (+ optional data-dl-label). */
  on(document, 'click', '[data-dl-event]', function (e, el) {
    dl({ event: el.dataset.dlEvent, label: el.dataset.dlLabel || el.textContent.trim().slice(0, 80) });
  });

  /* Outbound clicks to the brand site. */
  on(document, 'click', 'a[href*="vegaqura.com"]', function (e, a) {
    dl({ event: 'click_vegaqura', link_url: a.href, link_text: a.textContent.trim().slice(0, 80) });
  });

  /* Clicks on a review card or a rating summary. */
  on(document, 'click', '.review, .review-score, .pdp__rating', function (e, el) {
    var name = el.querySelector('.review__name');
    dl({ event: 'click_review', review_name: name ? name.textContent.trim() : '', location: el.className.split(' ')[0] });
  });

  /* Line item JSON from /cart/add.js → GA4 item. */
  function itemFromLine(line, qty) {
    return {
      item_id: line.sku || String(line.variant_id),
      item_name: line.product_title || line.title,
      item_brand: line.vendor,
      item_variant: line.variant_title,
      product_id: line.product_id,
      variant_id: line.variant_id,
      price: (line.price || 0) / 100,
      quantity: qty
    };
  }

  /* ------------------------------------------------------------------ */
  /* Mobile navigation                                                    */
  /* ------------------------------------------------------------------ */
  on(document, 'click', '[data-menu-toggle]', function (e, btn) {
    e.preventDefault();
    var panel = $('#header-mobile-nav');
    if (!panel) return;
    var open = panel.hasAttribute('hidden');
    if (open) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
    btn.setAttribute('aria-expanded', String(open));
  });

  /* ------------------------------------------------------------------ */
  /* Cart drawer                                                          */
  /* ------------------------------------------------------------------ */
  var lastFocus = null;
  var lockedScrollY = 0;

  function drawer() { return $('#cart-drawer'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.removeAttribute('hidden');
    // Pin the body at its current offset: on iOS, overflow:hidden alone does
    // not stop the page behind the drawer from scrolling.
    lockedScrollY = window.scrollY;
    document.body.style.top = -lockedScrollY + 'px';
    document.body.classList.add('drawer-open');
    var close = $('.drawer__close', d);
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.setAttribute('hidden', '');
    document.body.classList.remove('drawer-open');
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  on(document, 'click', '[data-cart-open]', function (e) {
    // No drawer rendered (e.g. drawer disabled) → let the link go to /cart
    if (!drawer()) return;
    e.preventDefault();
    openDrawer();
  });
  on(document, 'click', '[data-cart-close]', function (e) { e.preventDefault(); closeDrawer(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer() && !drawer().hasAttribute('hidden')) closeDrawer();
  });

  // Keep focus inside the open drawer.
  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (e.key !== 'Tab' || !d || d.hasAttribute('hidden')) return;
    var f = $$('a[href], button:not([disabled]), input, select, textarea', d)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function setBusy(state) {
    var d = drawer();
    if (d) d.classList.toggle('is-busy', state);
  }

  /* Re-render the drawer + header count from the Section Rendering API. */
  function refreshCart() {
    var url = (routes.cart_url || '/cart') + '?section_id=cart-drawer';
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#cart-drawer');
        var current = drawer();
        if (fresh && current) {
          var wasOpen = !current.hasAttribute('hidden');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.removeAttribute('hidden'); else current.setAttribute('hidden', '');
        }
        // The drawer section carries the item count; mirror it onto every badge.
        var source = doc.querySelector('[data-cart-count-source]');
        if (source) {
          var count = parseInt(source.textContent.trim(), 10) || 0;
          $$('[data-cart-count]').forEach(function (el) {
            el.textContent = count;
            if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
          });
        }
      });
  }

  function cartError(message) {
    var body = $('.drawer__body');
    if (!body) { window.alert(message); return; }
    var box = document.createElement('div');
    box.className = 'form-status form-status--error';
    box.setAttribute('role', 'alert');
    box.textContent = message;
    body.prepend(box);
  }

  /* Add to cart */
  on(document, 'submit', 'form[data-product-form]', function (e, form) {
    if (!drawer()) return; // no drawer → normal POST to /cart/add
    e.preventDefault();
    var btn = $('[data-add-button]', form);
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.textContent; btn.textContent = strings.adding || '...'; }

    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || strings.cartError);
        var qty = parseInt(form.querySelector('[name="quantity"]') && form.querySelector('[name="quantity"]').value, 10) || 1;
        dl({ ecommerce: null });
        dl({
          event: 'add_to_cart',
          ecommerce: {
            currency: T.currency || 'EUR',
            value: ((res.data.price || 0) / 100) * qty,
            items: [itemFromLine(res.data, qty)]
          }
        });
        return refreshCart().then(openDrawer);
      })
      .catch(function (err) { cartError(err.message || strings.cartError || 'Error'); })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); if (btn.dataset.label) btn.textContent = btn.dataset.label; }
      });
  });

  /* Change / remove a line item inside the drawer */
  function changeLine(key, quantity) {
    setBusy(true);
    return fetch(routes.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .catch(function () { cartError(strings.cartError || 'Error'); })
      .finally(function () { setBusy(false); });
  }

  on(document, 'click', '[data-line-change]', function (e, btn) {
    e.preventDefault();
    changeLine(btn.dataset.lineKey, parseInt(btn.dataset.lineChange, 10));
  });

  /* ------------------------------------------------------------------ */
  /* Quantity steppers (PDP + cart page)                                  */
  /* ------------------------------------------------------------------ */
  on(document, 'click', '[data-qty-step]', function (e, btn) {
    e.preventDefault();
    var input = $('input', btn.parentNode);
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var next = (parseInt(input.value, 10) || min) + parseInt(btn.dataset.qtyStep, 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------ */
  /* Product gallery                                                      */
  /* ------------------------------------------------------------------ */
  on(document, 'click', '[data-thumb]', function (e, btn) {
    e.preventDefault();
    var gallery = btn.closest('[data-gallery]');
    var main = $('[data-main-image]', gallery);
    if (!main) return;
    main.src = btn.dataset.full;
    main.srcset = btn.dataset.srcset || '';
    main.alt = btn.dataset.alt || '';
    $$('[data-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', String(t === btn)); });
  });

  /* ------------------------------------------------------------------ */
  /* Variant picker                                                       */
  /* ------------------------------------------------------------------ */
  $$('[data-variant-picker]').forEach(function (picker) {
    var data = $('[data-variant-json]', picker);
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var form = document.getElementById(picker.dataset.formId);

    function selected() {
      return $$('[data-option-index]', picker)
        .filter(function (el) { return el.getAttribute('aria-checked') === 'true'; })
        .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
        .map(function (el) { return el.dataset.optionValue; });
    }

    function update() {
      var chosen = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      var idInput = form && $('[name="id"]', form);
      var btn = form && $('[data-add-button]', form);

      if (match && idInput) idInput.value = match.id;

      if (btn) {
        var available = match && match.available;
        btn.disabled = !available;
        btn.textContent = available ? (strings.addToCart || btn.textContent)
          : (match ? strings.soldOut : strings.unavailable) || btn.textContent;
      }

      if (match) {
        // Price, compare-at, discount badge and savings line all follow the variant.
        var now = $('[data-price-now]');
        if (now) now.innerHTML = match.price;

        [['[data-price-was]', match.compare_at],
         ['[data-price-badge]', '\u2212' + match.off + '%'],
         ['[data-price-save]', match.save_text]].forEach(function (pair) {
          var el = $(pair[0]);
          if (!el) return;
          if (match.on_sale) { el.innerHTML = pair[1]; el.removeAttribute('hidden'); }
          else { el.setAttribute('hidden', ''); }
        });
      }

      if (match && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    }

    on(picker, 'click', '[data-option-index]', function (e, btn) {
      e.preventDefault();
      $$('[data-option-index="' + btn.dataset.optionIndex + '"]', picker)
        .forEach(function (el) { el.setAttribute('aria-checked', String(el === btn)); });
      update();
    });
  });

  /* ------------------------------------------------------------------ */
  /* Sticky buy bar                                                       */
  /* ------------------------------------------------------------------ */
  (function () {
    var bar = $('.buy-bar');

    // The bar's button targets the product form through its form="" attribute.
    // If that id ever stops matching, repair it here rather than silently doing
    // nothing when tapped.
    var productForm = $('form[data-product-form]');
    var barSubmit = bar && bar.querySelector('button[type="submit"][form]');
    // getAttribute, not .id: the product form contains <input name="id">, and a
    // form's named controls shadow that property — .id returns the input.
    var formId = productForm && productForm.getAttribute('id');
    if (formId && barSubmit && barSubmit.getAttribute('form') !== formId) {
      barSubmit.setAttribute('form', formId);
    }

    var inlineAdd = $('form[data-product-form] [data-add-button]');
    if (!bar || !inlineAdd) return;

    function onScreen() {
      var r = inlineAdd.getBoundingClientRect();
      return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
    }

    function sync() { bar.classList.toggle('is-hidden', onScreen()); }

    if (typeof window.IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { threshold: 0 }).observe(inlineAdd);
    } else {
      window.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
    }

    sync();
  })();

  /* ------------------------------------------------------------------ */
  /* Images that fail to load                                             */
  /* ------------------------------------------------------------------ */
  $$('[data-hide-if-broken]').forEach(function (wrapper) {
    var img = wrapper.querySelector('img');
    if (!img) return;

    function hide() { wrapper.hidden = true; }

    // A broken image may already have failed before this script ran.
    if (img.complete && img.naturalWidth === 0) hide();
    img.addEventListener('error', hide);
  });

  /* ------------------------------------------------------------------ */
  /* Open an accordion row when the URL hash points at it (#usage etc.)   */
  /* ------------------------------------------------------------------ */
  function openHashRow() {
    var id = location.hash.replace(/^#/, '');
    if (!id) return;
    var row = document.getElementById(id);
    if (!row || row.tagName !== 'DETAILS') return;
    row.open = true;
    row.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  openHashRow();
  window.addEventListener('hashchange', openHashRow);

  /* ------------------------------------------------------------------ */
  /* Localization switchers (language / country)                          */
  /* ------------------------------------------------------------------ */
  on(document, 'click', '[data-locale-value]', function (e, btn) {
    e.preventDefault();
    var form = btn.closest('form');
    if (!form) return;
    var input = $('input[name="locale_code"], input[name="country_code"]', form);
    if (input) input.value = btn.dataset.localeValue;
    form.submit();
  });

  /* ------------------------------------------------------------------ */
  /* Video feature: muted loop with a pause button; no autoplay when the  */
  /* visitor prefers reduced motion.                                      */
  /* ------------------------------------------------------------------ */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  $$('[data-video-feature]').forEach(function (box) {
    var video = $('video', box);
    var btn = $('[data-video-toggle]', box);
    if (!video || !btn) return;
    function setState(playing) {
      btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      btn.setAttribute('aria-label', playing ? btn.dataset.labelPause : btn.dataset.labelPlay);
    }
    if (reduceMotion) { video.removeAttribute('autoplay'); video.pause(); }
    video.addEventListener('play', function () { setState(true); });
    video.addEventListener('pause', function () { setState(false); });
    setState(!video.paused && !reduceMotion);
    btn.addEventListener('click', function () {
      if (video.paused) { video.play(); dl({ event: 'play_product_video' }); } else { video.pause(); }
    });
  });
})();
